import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Comment from "./Comment";
import styles from "./Comment.local.scss";
import classnames from "classnames";
import _ from "i18n";

export class CommentList extends PureComponent {
  render() {
    let {
      comments,
      //topicComments,
      fetching,
      //topicCommentsfetching,
      type,
      nbComment
    } = this.props;

    const commentsList = fetching ? Array(2).fill("") : comments;

    const commentListClass = fetching
      ? classnames(styles.comment__entities, styles.comment_fetching)
      : classnames(
          styles.comment__entities,
          type ? `comment-list-${type.toLowerCase()}` : ""
        );
    return (
      <div id="comments_entities" className={commentListClass}>
        {type === "TOPIC" ? (
          <div className={styles.nbComments}>
            <span>
              <i className="icon icon-bubbles" />
              {`${nbComment} ${_("comment(s)")}`}
            </span>
          </div>
        ) : null}
        {commentsList.map(elem => (
          <Comment
            comment={elem}
            type={type}
            key={`comment-${elem ? elem.id : Math.random()}`}
          />
        ))}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  fetching: state.comments.fetching,
  //topicCommentsfetching: state.topicViewer.comments.fetching,
  comments: state.comments.items,
  //topicComments: state.topicViewer.comments.items,
  nbComment: state.comments.nbResult
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentList);



// WEBPACK FOOTER //
// ./src/components/Reveal/Comments/CommentList.js